var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        width: '100%',
        userSelect: 'none',
    },
    containerCompact: {
        fontSize: '11px',
    },
    title: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'center',
        padding: '8px 0',
        color: '#323130',
    },
    titleCompact: {
        fontSize: '13px',
        padding: '6px 0',
    },
    titleButton: {
        width: '100%',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        font: 'inherit',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    tableCompact: {
        fontSize: '11px',
    },
    headerRow: {
        borderBottom: '1px solid #edebe9',
    },
    dayHeader: {
        padding: '8px 4px',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#605e5c',
        textTransform: 'uppercase',
    },
    dayHeaderCompact: {
        padding: '2px 0',
        fontSize: '10px',
    },
    weekHeader: {
        padding: '8px 4px',
        fontSize: '11px',
        fontWeight: 400,
        textAlign: 'center',
        color: '#a19f9d',
        width: '32px',
    },
    row: {
        borderBottom: '1px solid #f3f2f1',
    },
    cell: {
        padding: 0,
        verticalAlign: 'top',
        height: '80px',
        minHeight: '80px',
    },
    weekCell: {
        padding: '4px',
        fontSize: '11px',
        color: '#a19f9d',
        textAlign: 'center',
        verticalAlign: 'top',
        width: '32px',
    },
    eventsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1px',
        padding: '2px',
        overflow: 'hidden',
    },
    compactDotRow: {
        display: 'flex',
        justifyContent: 'center',
        gap: '2px',
        paddingBottom: '2px',
    },
    compactDot: {
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        display: 'inline-block',
    },
    moreButton: {
        background: 'none',
        border: 'none',
        padding: '2px 4px',
        fontSize: '11px',
        color: '#0078d4',
        cursor: 'pointer',
        textAlign: 'left',
    },
};
export default styles;
//# sourceMappingURL=DayPicker.styles.js.map